// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RoomsBeds-roomsBedGap-wrEQY {
    gap: 11px;
}

.RoomsBeds-bedIcon-je8qv {
    width: 100%;
    max-width: 22px;
    min-width: 22px;
}

.RoomsBeds-bedsWidth-zZ16Q {
    width: 70%;
}

@media screen and (max-width: 767px) {
    .RoomsBeds-roomsBedGapSection-B94Ea {
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
        -webkit-box-align: start;
            -ms-flex-align: start;
                align-items: flex-start;
        gap: 10px;
    }

    .RoomsBeds-bedsWidth-zZ16Q {
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/SearchListing/Filters/MoreFilters/RoomsBeds/RoomsBeds.css"],"names":[],"mappings":"AAAA;IACI,SAAS;AACb;;AAEA;IACI,WAAW;IACX,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI;QACI,4BAAsB;QAAtB,6BAAsB;YAAtB,0BAAsB;gBAAtB,sBAAsB;QACtB,wBAAuB;YAAvB,qBAAuB;gBAAvB,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":[".roomsBedGap {\n    gap: 11px;\n}\n\n.bedIcon {\n    width: 100%;\n    max-width: 22px;\n    min-width: 22px;\n}\n\n.bedsWidth {\n    width: 70%;\n}\n\n@media screen and (max-width: 767px) {\n    .roomsBedGapSection {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 10px;\n    }\n\n    .bedsWidth {\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"roomsBedGap": `RoomsBeds-roomsBedGap-wrEQY`,
	"bedIcon": `RoomsBeds-bedIcon-je8qv`,
	"bedsWidth": `RoomsBeds-bedsWidth-zZ16Q`,
	"roomsBedGapSection": `RoomsBeds-roomsBedGapSection-B94Ea`
};
module.exports = ___CSS_LOADER_EXPORT___;
